import {
  REQUEST_DELETE_CAR_BOOKMARK,
  RESPONSE_DELETE_CAR_BOOKMARK,
  REQUEST_DELETE_CAR_BOOKMARK_FAILURE
} from './../actions/deleteCarBookmarkActions'

import { states as queriesStates } from './queriesStates'

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  errors: [],
}

const deleteCarBookmarkReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DELETE_CAR_BOOKMARK:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.REQUEST
        }
      )
    case RESPONSE_DELETE_CAR_BOOKMARK:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.READY
        }
      )
    case REQUEST_DELETE_CAR_BOOKMARK_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.FAILURE,
          errors: action.errors
        }
      )
    default:
      return state
  }
}

export default deleteCarBookmarkReducer